import React, { useEffect, useState } from "react";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";
import { errorToast, successToast } from "./common/showtoast";
import { useParams, useHistory } from "react-router-dom";

export default function Activation() {
  const { step } = useParams();
  const history = useHistory();
  const [stateObj, setStateObj] = useState({
    memberid: "",
    membername: "",
    selforothers: "self",
    tableData: [],
    packageData: [],
    code: "",
  });
  useEffect(() => {
    setStateObj({
      ...stateObj,
      selforothers: step === "team" ? "Others" : "self",
    });
    getJoiningList();
  }, [step]);
  const buyContractConfirm = async (json) => {
    let res = await ApiRequest("buycontract.asp", "POST", json, {
      Authorization: localStorage.getItem("token"),
    });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        history.push("/login");
      }
      return;
    }
    successToast(res.message);
    setStateObj({ ...stateObj, memberid: "", membername: "" });
  };
  const getName = async () => {
    if (!stateObj.memberid) {
      return;
    }
    let jsoninput = {
      memberid: stateObj.memberid,
    };
    let res = await ApiRequest("getname.asp", "POST", jsoninput, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        history.push("/login");
      }
      return;
    }
    setStateObj({ ...stateObj, membername: res.fullname });
  };
  const getJoiningList = async () => {
    let res = await ApiRequest("joining_product_list.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        history.push("/login");
      }
      return;
    }
    setStateObj({ ...stateObj, packageData: res.items });
  };

  return (
    <div>
      <PageHeader title="Activation" />
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
          <div className="card overflow-hidden dash1-card border-0 ">
            <div className="card-body" style={{ justifyContent: "center" }}>
              <h5 className=" mt-3 mb-3">
                {stateObj.selforothers === "self" ? "Self " : "Team "}Activation
              </h5>
              <div
                className="search-element row mb-5"
                style={{
                  display: stateObj.selforothers === "Others" ? "flex" : "none",
                }}
              >
                <div
                  className="input-container ml-auto mr-auto"
                  style={{ width: "auto" }}
                >
                  <i className="las la-user-circle inputicon"></i>
                  <input
                    type="text"
                    className="form-control col-lg-12"
                    onBlur={() => getName()}
                    placeholder="Memberid"
                    aria-label="memberid"
                    tabIndex="1"
                    onChange={(e) => {
                      setStateObj({ ...stateObj, memberid: e.target.value });
                    }}
                    value={stateObj.memberid}
                  />
                </div>
              </div>

              <div
                className="search-element row mb-5"
                style={{
                  display: stateObj.selforothers === "Others" ? "flex" : "none",
                }}
              >
                <div
                  className="input-container ml-auto mr-auto"
                  style={{ width: "auto" }}
                >
                  <i className="las la-user inputicon"></i>
                  <input
                    type="text"
                    className="form-control col-lg-12"
                    placeholder="membername"
                    aria-label="membername"
                    tabIndex="1"
                    readOnly
                    value={stateObj.membername}
                  />
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                    style={{ textAlign: "center" }}
                  >
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>MRP</th>
                        <th>PV</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stateObj.packageData.length <= 0 ? (
                        <tr>
                          <td colSpan="5">No Details Found</td>
                        </tr>
                      ) : (
                        stateObj.packageData.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className="tabletd">{index + 1}</td>
                              <td>{item.product_name}</td>
                              <td>{item.Price}</td>
                              <td>{item.mrp}</td>
                              <td>{item.PV}</td>
                              <td>
                                <input
                                  name="package"
                                  type="radio"
                                  onChange={(e) => {
                                    setStateObj({
                                      ...stateObj,
                                      code: e.target.value,
                                    });
                                  }}
                                  value={item.code}
                                  checked={stateObj.code === item.code}
                                />
                              </td>
                            </tr>
                          );
                        })
                      )}
                      <tr>
                        <td colSpan="6">
                          <input
                            className="form-control ml-auto mr-auto col-lg-6"
                            placeholder="Address line 1"
                            onChange={(e) => {
                              setStateObj({
                                ...stateObj,
                                addressline1: e.target.value,
                              });
                            }}
                            value={stateObj.addressline1}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="6">
                          <input
                            className="form-control ml-auto mr-auto col-lg-6"
                            placeholder="Address line 2"
                            onChange={(e) => {
                              setStateObj({
                                ...stateObj,
                                addressline2: e.target.value,
                              });
                            }}
                            value={stateObj.addressline2}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="6">
                          <input
                            className="form-control ml-auto mr-auto col-lg-6"
                            placeholder="City"
                            onChange={(e) => {
                              setStateObj({
                                ...stateObj,
                                city: e.target.value,
                              });
                            }}
                            value={stateObj.city}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="6">
                          <input
                            className="form-control ml-auto mr-auto col-lg-6"
                            placeholder="State"
                            onChange={(e) => {
                              setStateObj({
                                ...stateObj,
                                state: e.target.value,
                              });
                            }}
                            value={stateObj.state}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="6">
                          <input
                            className="form-control ml-auto mr-auto col-lg-6"
                            placeholder="Pincode"
                            onChange={(e) => {
                              setStateObj({
                                ...stateObj,
                                Pincode: e.target.value,
                              });
                            }}
                            value={stateObj.Pincode}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="6">
                          <div
                            style={{
                              justifyContent: "center",
                              display: "grid",
                            }}
                          >
                            <button
                              className="btn primebtn"
                              onClick={async () => {
                                if (
                                  !stateObj.memberid &&
                                  stateObj.selforothers === "Others"
                                ) {
                                  errorToast("Enter valid memberid");
                                  return;
                                } else if (!stateObj.code) {
                                  errorToast("Please Select Product");
                                  return;
                                } else if (!stateObj.addressline1) {
                                  errorToast(
                                    "Please Enter valid address line 1"
                                  );
                                  return;
                                } else if (!stateObj.addressline2) {
                                  errorToast(
                                    "Please Enter valid address line 2"
                                  );
                                  return;
                                } else if (!stateObj.city) {
                                  errorToast("Please enter a valid city");
                                  return;
                                } else if (!stateObj.state) {
                                  errorToast("Please enter a valid state");
                                  return;
                                } else if (!stateObj.Pincode) {
                                  errorToast("Please enter a valid pincode");
                                  return;
                                }
                                let json = {
                                  toupuser:
                                    stateObj.selforothers === "Others"
                                      ? stateObj.memberid
                                      : localStorage.getItem("username"),
                                  productcode: stateObj.code,
                                  shipping_address1: stateObj.addressline1,
                                  shipping_address2: stateObj.addressline2,
                                  shipping_city: stateObj.city,
                                  shipping_district: stateObj.city,
                                  shipping_pincode: stateObj.Pincode,
                                  shipping_state: stateObj.state,
                                };
                                await buyContractConfirm(json);
                              }}
                            >
                              Purchase
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
